<!-- tipos-cob-form.svelte -->

<script>
	
	export let formdata = {}


</script>

	
<div class="card-body overflow-auto">
	<pre>{JSON.stringify(formdata,null,2)}</pre>

</div>

<div class="card-footer text-end">
	<button class="btn btn-sm btn-primary">Guardar</button>
</div>


